

































import Vue from 'vue'

import { toastModule } from '@app/utils/store-accessor'
import { ToastItem } from '@app/store/toast'
import CpToast from '@ui/src/components/CpToast/CpToast.vue'
import CpLinkArrow from '@ui/src/components/CpLinkArrow/CpLinkArrow.vue'
export default Vue.extend({
  components: {
    CpToast,
    CpLinkArrow,
  },
  computed: {
    items(): ToastItem[] {
      return toastModule.toastItems
    },
  },
  methods: {
    closeToast(id: string) {
      toastModule.hideToastItem(id)
    },
  },
})
